import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import type { VisualTopImageProps } from '@components/VisualTopImage/VisualTopImage.types'
import { lazyImport } from '@helpers'
import type { CartDrawerData, CollectionMessageData } from '@velasca/types'

// Con questo import lazy, ora tutti gli HOC sono lazyloadati.
// Questo significa che Algolia non viene caricato per esempio in pagina prodotto (come accadeva invece prima)
const { ConnectedApparelMacroCategoryApp } = lazyImport(
  () => import('./ConnectedApparelMacroCategoryApp'),
  'ConnectedApparelMacroCategoryApp',
)

export const renderApparelMacroCategoryApp = (
  apparelMacroCategoryEl: HTMLElement | null,
  visualTopImageData: VisualTopImageProps,
  cartDrawerData: CartDrawerData,
  headerEl: HTMLElement | null,
  headerData: any,
  promotionalBannerData: any,
  productLocaleElJson: any,
  collectionTopMessageData: CollectionMessageData,
  minisearchData: any,
) => {
  if (apparelMacroCategoryEl) {
    ReactDOM.createRoot(apparelMacroCategoryEl).render(
      <Suspense fallback={null}>
        <ConnectedApparelMacroCategoryApp
          apparelMacroCategoryEl={apparelMacroCategoryEl}
          visualTopImageData={visualTopImageData}
          cartDrawerData={cartDrawerData}
          headerEl={headerEl}
          headerData={headerData}
          promotionalBannerData={promotionalBannerData}
          productLocaleElJson={productLocaleElJson}
          collectionTopMessageData={collectionTopMessageData}
          minisearchData={minisearchData}
        />
      </Suspense>,
    )
  }
}
